import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Strikethrough = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5942 4.98034H11.9987C11.9343 3.17203 10.2665 1.82019 7.94903 1.82019C5.655 1.82019 3.85254 3.15448 3.85254 5.16761C3.85254 5.90895 4.09911 6.51221 4.54697 7.00003H2.0011V8.00003H13.9988V7.00003H7.26217C6.38651 6.73941 5.25705 6.24242 5.25705 5.09738C5.25705 3.95037 6.31044 3.10766 7.90222 3.10766C9.35354 3.10766 10.4537 3.79821 10.5942 4.98034ZM10.7581 10.692C10.7581 9.79605 10.1252 9.32199 9.27505 8.99279H11.6102C11.9458 9.43647 12.1626 9.99852 12.1626 10.7154C12.1626 12.6583 10.5942 14.1799 7.83199 14.1799C5.25705 14.1799 3.66527 12.8456 3.52482 10.8793H5.02297C5.14001 12.237 6.40407 12.869 7.83199 12.869C9.494 12.869 10.7581 12.0029 10.7581 10.692Z"
        />
      </svg>
    )
  },
)

export default Strikethrough
